const ACCESS_COUNT_STORAGE_KEY = 'accessCount';
const DAILY_ACCESS_STORAGE_KEY = 'dailyAccessLastTrackedAt';
const VISITOR_ID_STORAGE_KEY = 'dailyAccessVisitorId';

type AccessPayload = {
  date: string;
  path: string;
  referrer: string;
  title: string;
  userAgent: string;
  visitorId: string;
};

const getTodayKey = () => new Date().toISOString().slice(0, 10);

const getAccessCounterUrl = () => {
  if (process.env.REACT_APP_ACCESS_COUNTER_URL) {
    return process.env.REACT_APP_ACCESS_COUNTER_URL;
  }

  if (process.env.REACT_APP_API_URI) {
    return `${process.env.REACT_APP_API_URI.replace(/\/$/, '')}/analytics/access`;
  }

  return '';
};

const getVisitorId = () => {
  const storedVisitorId = localStorage.getItem(VISITOR_ID_STORAGE_KEY);

  if (storedVisitorId) {
    return storedVisitorId;
  }

  const browserCrypto =
    typeof crypto !== 'undefined'
      ? (crypto as Crypto & { randomUUID?: () => string })
      : undefined;

  const visitorId =
    browserCrypto && typeof browserCrypto.randomUUID === 'function'
      ? browserCrypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

  localStorage.setItem(VISITOR_ID_STORAGE_KEY, visitorId);

  return visitorId;
};

const createPayload = (): AccessPayload => ({
  date: getTodayKey(),
  path: `${window.location.pathname}${window.location.search}`,
  referrer: document.referrer,
  title: document.title,
  userAgent: navigator.userAgent,
  visitorId: getVisitorId(),
});

const sendAccessCount = (url: string, payload: AccessPayload) => {
  const body = JSON.stringify(payload);

  if (navigator.sendBeacon) {
    const sent = navigator.sendBeacon(
      url,
      new Blob([body], { type: 'application/json' }),
    );

    if (sent) {
      return Promise.resolve();
    }
  }

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
    keepalive: true,
  }).then(() => undefined);
};

// Registra um acesso unico por navegador a cada dia. A soma global precisa ser feita no endpoint da aplicacao/API.
export function incrementAccessCount(): number {
  const current = Number(localStorage.getItem(ACCESS_COUNT_STORAGE_KEY)) || 0;
  const next = current + 1;
  const today = getTodayKey();
  const accessCounterUrl = getAccessCounterUrl();

  localStorage.setItem(ACCESS_COUNT_STORAGE_KEY, String(next));

  if (
    accessCounterUrl &&
    localStorage.getItem(DAILY_ACCESS_STORAGE_KEY) !== today
  ) {
    localStorage.setItem(DAILY_ACCESS_STORAGE_KEY, today);

    sendAccessCount(accessCounterUrl, createPayload()).catch(() => {
      localStorage.removeItem(DAILY_ACCESS_STORAGE_KEY);
    });
  }

  return next;
}

export function getAccessCount(): number {
  return Number(localStorage.getItem(ACCESS_COUNT_STORAGE_KEY)) || 0;
}
